const OVERAGE_FACTOR = 1.2;

function roundQty(value) {
  return Math.round((Number(value) || 0) * 10000) / 10000;
}

export function maxReceivableQty(requestedQty) {
  const requested = roundQty(requestedQty);
  if (requested <= 0) return null;
  return roundQty(requested * OVERAGE_FACTOR);
}

export function remainingReceivableQty(requestedQty, alreadyReceivedQty) {
  const requested = roundQty(requestedQty);
  const received = roundQty(alreadyReceivedQty);
  if (requested <= 0) return null;
  if (received >= requested) return 0;
  const maxQty = maxReceivableQty(requested);
  return Math.max(roundQty(maxQty - received), 0);
}

export function isReceivedUpToAllowance(requestedQty, alreadyReceivedQty) {
  const requested = roundQty(requestedQty);
  if (requested <= 0) return false;
  return roundQty(alreadyReceivedQty) >= requested;
}

export function replacementReceivableQty(requestedQty, alreadyReceivedQty, thisShipmentQty) {
  const requested = roundQty(requestedQty);
  if (requested <= 0) return null;
  const otherReceived = Math.max(
    roundQty(roundQty(alreadyReceivedQty) - roundQty(thisShipmentQty)),
    0
  );
  return Math.max(roundQty(maxReceivableQty(requested) - otherReceived), 0);
}
